import { Gift } from '@/app/shared/interface/cart.interface';
import { WalletType } from '@/app/shared/interface/user.interface';
import { USERNAME } from '@/app/shared/services/auth.service';
import { CartService } from '@/app/shared/services/cart.service';
import { GiftService } from '@/app/shared/services/gift.service';
import { WalletService } from '@/app/shared/services/wallet.service';
import { isPlatformBrowser } from '@angular/common';
import { Component, EventEmitter, Inject, Input, Output, PLATFORM_ID, TemplateRef, TransferState, ViewChild } from '@angular/core';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-gift-detail',
  templateUrl: './gift-detail.component.html',
  styleUrl: './gift-detail.component.scss'
})
export class GiftDetailComponent {

  @ViewChild("giftModal", { static: false }) giftModal: TemplateRef<any>;

  @Input() giftId: string;
  @Input() balance: number = 0;
  @Input() isExchanged: boolean = false;

  public closeResult: string;
  public modalOpen: boolean = false;
  selectedGift: Gift;

  agreed: boolean = false;
  
  constructor(
    private modalService: NgbModal,
    private giftService: GiftService,
    @Inject(PLATFORM_ID) private platformId: Object,
    private toastService: ToastrService,
    private cartService: CartService,
    private walletService: WalletService,
    private transferState: TransferState,
  ) { }


  async openModal() {
    if (isPlatformBrowser(this.platformId)) { // For SSR
      this.modalOpen = true;
      this.agreed = false;
      let modal = this.modalService.open(this.giftModal, {
        ariaLabelledBy: 'Gift-Modal',
        centered: true,
        windowClass: 'theme-modal modal-lg',
        backdrop: 'static',
      });

      modal.shown.subscribe(() => {
        this.getGiftDetail();
      });

      modal.result.then((result) => {
      }, (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        this.confirm(false);
      });
    }
  }

  private getDismissReason(reason: ModalDismissReasons): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }
  
  getGiftDetail() {
    const body: any = {
      giftId: this.giftId
    }
    this.giftService.getGiftDetail(body).subscribe({
      next: (res) => {
        if (res) {
          this.selectedGift = res;
          this.selectedGift.quantity = 1;
        }
      }
    });
  }

  confirm(value: boolean) {
    if (value) {
      this.confirmExchange();
      this.modalService.dismissAll();
    }
  }

  confirmExchange() {
    let exchangeAmount = this.selectedGift?.quantity && this.selectedGift.quantity > 0 ? this.selectedGift.quantity : 1;
    this.giftService.exchangeGift({ giftId: this.giftId, quantity: exchangeAmount }).subscribe({
      next: (res) => {
        if (res && res.statusCode === 200) {
          this.toastService.success(res.message, '', {
            positionClass: 'toast-top-right',
          });
          this.modalService.dismissAll();
          this.cartService.refreshCart();
          this.giftService.refreshExchangedGifts();
          this.walletService.refreshWallet(this.transferState.get(USERNAME, ''), WalletType.Coin);
        }
        else {
          this.toastService.error(res.message || 'Đổi quà thất bại. Vui lòng thử lại sau.', '', {
            positionClass: 'toast-top-right',
          });
          return;
        }
      }
    });
  }

  agree() {
    this.agreed = !this.agreed;
  }

  onQuantityError() {
    this.toastService.error('Số lượng quà tặng vượt quá số lượng còn lại!');
  }
}
